/**
 * Map a company's StrengthFormat setting code to its display unit.
 *
 * Mirrors the legacy PageBase.getStrengthFormat():
 *   "02" -> Psi, "03" -> N/mm², anything else (incl. "01"/blank) -> MPa.
 * Single source of truth for the strength unit shown across the app.
 */
export const strengthUnitFromFormat = (format?: string | null): string => {
  switch ((format || '').trim()) {
    case '02':
      return 'Psi';
    case '03':
      return 'N/mm²';
    default:
      return 'MPa';
  }
};
